import React from 'react';
import { cn } from '../../utils/cn';
import { formatCurrency } from '../../utils/currencyFormatting';
import type { Group, Expense } from '../../types';
import type { User } from 'firebase/auth';

interface GroupSummaryCardsProps {
    expenses: Expense[];
    group: Group;
    currentUser: User | null | undefined;
}

export const GroupSummaryCards: React.FC<GroupSummaryCardsProps> = ({
    expenses,
    group,
    currentUser
}) => {
    const totalSpending = expenses.reduce((sum, e) => sum + e.amount, 0);

    const calculateMyBalance = () => {
        if (!currentUser) return 0;
        const paidByMe = expenses.filter(e => e.payerId === currentUser.uid).reduce((sum, e) => sum + e.amount, 0);
        const myShare = expenses.reduce((sum, e) => {
            const split = e.splitWith.find(s => s.userId === currentUser.uid);
            return sum + (split?.amount ?? 0);
        }, 0);
        return paidByMe - myShare;
    };

    const myBalance = calculateMyBalance();

    return (
        <div className="grid grid-cols-2 gap-4">
            <div className="rounded-2xl bg-primary-600 p-4 text-white shadow-lg shadow-primary-200">
                <p className="text-[10px] font-bold uppercase tracking-wider opacity-80">Group Spending</p>
                <p className="text-2xl font-black">
                    {formatCurrency(totalSpending, group.currency)}
                </p>
            </div>
            <div className="rounded-2xl bg-bg-card p-4 text-text-heading shadow-sm border border-border-default">
                <p className="text-[10px] font-bold uppercase tracking-wider text-text-faint">Your Balance</p>
                <p className={cn(
                    "text-2xl font-black",
                    myBalance >= 0 ? "text-green-600" : "text-red-600"
                )}>
                    {formatCurrency(myBalance, group.currency)}
                </p>
            </div>
        </div>
    );
};
